var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7916 28.0002H3.20819C1.43832 28.0002 0 26.5616 0 24.792V7.87518C0 6.10532 1.43832 4.66699 3.20819 4.66699H7.2916C7.7746 4.66699 8.1666 5.05899 8.1666 5.54199C8.1666 6.02499 7.7746 6.41699 7.2916 6.41699H3.20819C2.40433 6.41699 1.75 7.07132 1.75 7.87518V24.792C1.75 25.5956 2.40433 26.2502 3.20819 26.2502H24.7916C25.5955 26.2502 26.25 25.5956 26.25 24.792V14.8752C26.25 14.3922 26.642 14.0002 27.125 14.0002C27.608 14.0002 28 14.3922 28 14.8752V24.792C28 26.5616 26.5615 28.0002 24.7916 28.0002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.68124 18.6284C7.74533 18.6448 7.80963 18.6519 7.87372 18.6519C8.20505 18.6519 8.52121 18.4581 8.67181 18.1548C10.312 14.8729 13.6104 12.8336 17.2806 12.8336H18.6666V16.6252C18.6666 16.9822 18.8836 17.303 19.215 17.4372C19.5427 17.5692 19.9242 17.4897 20.1716 17.2319L27.755 9.3569C28.0816 9.01853 28.0816 8.4819 27.755 8.14353L20.1716 0.268526C19.9242 0.0106826 19.545 -0.0696397 19.215 0.0632339C18.8836 0.197389 18.6666 0.518251 18.6666 0.875215V4.66702H18.375C12.103 4.66702 7 9.77005 7 16.042V17.792C7 18.1979 7.28583 18.5363 7.68124 18.6284ZM8.82349 14.8402C9.41736 10.0977 13.4749 6.41702 18.375 6.41702H19.5416C20.0246 6.41702 20.4166 6.02503 20.4166 5.54202V3.0452L25.9103 8.75022L20.4166 14.4552V11.9586C20.4166 11.4756 20.0246 11.0836 19.5416 11.0836H17.2806C13.9859 11.0836 10.9443 12.4743 8.82349 14.8402Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.1d0830339ce5e87ece89293587269ea3.svg";
export { ForwardRef as ReactComponent };